<template>
  <v-container fluid class="login px-0">
    <img class="imgBg" src="../img/background-login.png" alt="" />
    <div class="d-flex flex-column align-center" style="margin-top: 15vh">
      <img class="diageo" src="../img/logo.png" style="width: 60%;" alt="" />
      <h1 class="titulo my-5">Login</h1>
      <div class="circle d-flex align-center justify-center" style="width: 72px; height: 72px;">
        <img src="../img/avatar.png" width="35" alt="Icone Perfil" />
      </div>
      <form style="width:100%; text-align:center" @submit.prevent="" autocomplete="false">
        <div class="mt-7 mb-5" style="width: 70%; margin:auto">
          <v-text-field v-model="u.email" solo :rules="[rules.required]" label="Usuário"></v-text-field>
          <v-text-field v-model="u.password" solo :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Senha"
            hint="At least 8 characters" @click:append="show1 = !show1" autocomplete="false"></v-text-field>
          <v-checkbox v-model="u.majority" dark label="Declaro que tenho mais de 18 anos." color="white" value=""
            class="mt-0 mb-1" hide-details></v-checkbox>
          <v-checkbox v-model="u.terms" dark label="Aceito os termos e condições de uso." color="white" value=""
            class="mt-0 mb-1" hide-details></v-checkbox>
        </div>
        <v-btn elevation="2" color="#FF8723" :loading="loading" @click="login($event)" style="width: 70%; height: 50px;">
          Entrar
        </v-btn>
      </form>
    </div>
    <v-snackbar v-model="snackbar" :timeout="4000">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn text x-small v-bind="attrs" @click="snackbar = false">
          X
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card class="d-flex justify-center flex-column pa-3">
        <v-btn class="align-end" style="margin: auto; margin-right: 0;" color="green darken-1" text
          @click="dialog = false">
          <v-icon x-small color="#FF8723">mdi-close</v-icon>
        </v-btn>
        <v-text-field v-model="u.email1" solo :rules="[rules.required, rules.email]" label="E-mail"></v-text-field>
        <v-btn class="mx-auto my-2" elevation="2" color="#FF8723" :loading="loading" style="width: 70%; height: 50px;"
          @click="esqueceuSenha()">
          Enviar
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import "../css/login.css";
export default {
  name: "login",
  data() {
    return {
      snackbar: false,
      text: "",
      dialog: false,
      show1: false,
      termo: false,
      password: "",
      loading: false,
      u: { email: "", password: "", email1: "" },
      rules: {
        required: (value) => !!value || "Obrigatório.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Email inválido.";
        },
      },
    };
  },
  methods: {
    login: function (e) {
      e.preventDefault();
      let email = this.u.email;
      let pass = this.u.password;
      if (!this.u.majority) {
        this.text = "Desculpe, você precisa ser maior parar utilizar este site."
        this.snackbar = true;
        return
      }
      if (!this.u.terms) {
        this.text = "Desculpe, você precisa aceitar os termos e condições de uso parar utilizar este site."
        this.snackbar = true;
        return
      }
      this.$store
        .dispatch("login", { email, pass })
        .then(() => {
          this.$gtag.query('set', {
            id_usuario: this.$store.state.user.scope.idUsuario,
            session_key: this.$store.state.token
          })
          this.$router.push("/");
        })
        .catch((resp) => {
          console.log(resp)
          this.text = "Login ou senha inválidos."
          if (resp.err == "user suspended") this.text = "Seu usuário foi suspenso! Entre em contato com um administrador."

          this.snackbar = true;
        });
    },
    esqueceuSenha(e) {
      e.preventDefault();
      let strEmail = this.u.strLogin;
      if (strEmail != "") {
        alert("Por favor utilize um email válido");
      }
      this.$http
        .post("auth/password/requests", { emai: strEmail })
        .then((response) => {
          if (response.data != undefined) {
            alert("Um email foi enviado com as informações necessarias.");
          }
        });
    },
  },
};
</script>
